import { render } from "./BoxEditorDialog.vue?vue&type=template&id=c4bc3576&scoped=true"
import script from "./BoxEditorDialog.vue?vue&type=script&lang=ts"
export * from "./BoxEditorDialog.vue?vue&type=script&lang=ts"

import "./BoxEditorDialog.vue?vue&type=style&index=0&id=c4bc3576&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-c4bc3576"

export default script